export function distance(point1, point2) {
    let a = point1.leaflet_params.endPoint[0] - point2.leaflet_params.endPoint[0]
    let b = point1.leaflet_params.endPoint[1] - point2.leaflet_params.endPoint[1]
    return Math.sqrt(a * a + b * b)
}

export function imgNameToUrl(imgName) {
    return 'https://img.lkval.com/' + imgName
}